<section class="atw-page my-jobs-page" [attr.dir]="isAr ? 'rtl' : 'ltr'">
  <span class="shape shape-1"></span>
  <span class="dots dots-left"></span>

  <div class="atw-container">
    <div class="section-title my-jobs-title">
      <span>
        <b>{{ jobs.length || '0' }}</b>
      </span>

      <div>
        <h2>{{ isAr ? 'وظائفي' : 'My Jobs' }}</h2>
        <p>{{ isAr ? 'تابع الوظائف التي نشرتها شركتك وحالتها الحالية.' : 'Track the jobs posted by your company and their current status.' }}</p>
      </div>
    </div>

    <div class="my-jobs-actions">
      <a routerLink="/create-job" class="submit-btn">
        {{ isAr ? 'إضافة وظيفة' : 'Add Job' }}
      </a>
    </div>

    <div class="apply-card loading-card" *ngIf="loading">
      {{ isAr ? 'جاري تحميل الوظائف...' : 'Loading jobs...' }}
    </div>

    <div class="error-message" *ngIf="!loading && errorMessage">
      {{ errorMessage }}
    </div>

    <div class="apply-card empty-card" *ngIf="!loading && !errorMessage && !jobs.length">
      <h3>{{ isAr ? 'لا توجد وظائف منشورة بعد' : 'No jobs posted yet' }}</h3>
      <p>{{ isAr ? 'ابدأ بإضافة وظيفة جديدة لتظهر هنا.' : 'Add a new job and it will appear here.' }}</p>
    </div>

    <div class="my-jobs-grid" *ngIf="!loading && jobs.length">
      <article class="job-card" *ngFor="let job of jobs; trackBy: trackById">
        <div class="job-card-head">
          <span class="status-pill" [ngClass]="getStatusClass(job?.status)">
            {{ getStatusLabel(job?.status) }}
          </span>

          <span class="job-id">#{{ job?.id }}</span>
        </div>

        <h3>{{ getJobTitle(job) }}</h3>

        <div class="job-meta">
          <span>{{ getLocation(job) }}</span>
          <span>{{ getEmploymentTypeLabel(job?.employment_type) }}</span>
          <span>{{ getWorkModelLabel(job?.work_model) }}</span>
        </div>

        <p>{{ job?.salary_note || job?.description || (isAr ? 'لا يوجد وصف مختصر.' : 'No summary available.') }}</p>

        <div class="job-card-actions">
          <a [routerLink]="['/job', job?.id]" class="secondary-action">
            {{ isAr ? 'عرض التفاصيل' : 'View Details' }}
          </a>

          <button type="button" class="secondary-action applicants-action" (click)="openApplicants(job)">
            {{ isAr ? 'عرض المتقدمين' : 'View Applicants' }}
          </button>
        </div>
      </article>
    </div>
  </div>
</section>

<div class="applicants-backdrop" *ngIf="applicantsModalOpen" (click)="closeApplicants()">
  <div class="applicants-modal" (click)="$event.stopPropagation()">
    <button type="button" class="applicants-close" (click)="closeApplicants()">
      ×
    </button>

    <div class="applicants-head">
      <span>{{ applicants.length || '0' }}</span>

      <div>
        <h2>{{ isAr ? 'المتقدمين على الوظيفة' : 'Job Applicants' }}</h2>
        <p>{{ getJobTitle(selectedApplicantsJob) }}</p>
      </div>
    </div>

    <div class="applicants-loading" *ngIf="applicantsLoading">
      {{ isAr ? 'جاري تحميل المتقدمين...' : 'Loading applicants...' }}
    </div>

    <div class="error-message" *ngIf="!applicantsLoading && applicantsError">
      {{ applicantsError }}
    </div>

    <div class="applicants-empty" *ngIf="!applicantsLoading && !applicantsError && !applicants.length">
      <h3>{{ isAr ? 'لا يوجد متقدمين بعد' : 'No applicants yet' }}</h3>
      <p>{{ isAr ? 'عند تقديم المرشحين على هذه الوظيفة سيظهرون هنا.' : 'Candidates who apply to this job will appear here.' }}</p>
    </div>

    <div class="applicants-list" *ngIf="!applicantsLoading && applicants.length">
      <article class="applicant-card" *ngFor="let application of applicants; trackBy: trackByApplicationId">
        <div class="applicant-avatar">
          {{ getApplicantName(application).charAt(0) }}
        </div>

        <div class="applicant-info">
          <div class="applicant-title-row">
            <h3>{{ getApplicantName(application) }}</h3>

            <span class="application-status" [ngClass]="getApplicationStatusClass(application?.status)">
              {{ getApplicationStatusLabel(application?.status) }}
            </span>
          </div>

          <div class="applicant-meta">
            <span *ngIf="getApplicantEmail(application)">{{ getApplicantEmail(application) }}</span>
            <span *ngIf="getApplicantPhone(application)">{{ getApplicantPhone(application) }}</span>
            <span *ngIf="application?.created_at">{{ application?.created_at | date:'mediumDate' }}</span>
          </div>
        </div>

        <a
          *ngIf="getApplicantCv(application)"
          class="secondary-action cv-action"
          [href]="getApplicantCv(application)"
          target="_blank"
          rel="noopener"
        >
          {{ isAr ? 'عرض CV' : 'View CV' }}
        </a>
      </article>
    </div>
  </div>
</div>
